export default __webpack_public_path__ + "static/media/ic-warning-red.3dee2f7c.svg";